export default class DiptychController {
    constructor() {
        this.init();
    }

    init() {
        if (document.querySelectorAll('.diptych-container').length) {
            document.querySelectorAll('.diptych-container').forEach(sliderContainer => {
                const slider = sliderContainer.querySelector('input');
                const image = sliderContainer.querySelector('.overlay-image');
                const divider = sliderContainer.querySelector('.divider');
                const tooltip = divider.querySelector('.tooltip');
                
                slider.addEventListener('input', () => {
                    let slideValue = slider.value / 1000;
                    image.style.clipPath = "polygon(0 0," + slideValue + "% 0," + slideValue + "% 100%, 0 100%)";
                    divider.style.transform = "translateX(" + slideValue + "%)";
                    tooltip.classList.add('hide');
                });
            });
        }
    }
}